import React from 'react'

const RmgProgramLogo = ({ imagePath }) => (
    <img src={ imagePath }/>
)

export default RmgProgramLogo
